/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a ridgeline (joyplot) from grouped data — compare distributions over a sequence, no sign-up.`)
};

const es_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de cordillera (joyplot) a partir de datos agrupados — compara distribuciones a lo largo de una secuencia, sin registro.`)
};

const de_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle ein Ridgeline-Diagramm (Joyplot) aus gruppierten Daten — vergleiche Verteilungen über eine Abfolge hinweg, keine Anmeldung nötig.`)
};

const nl_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een ridgeline (joyplot) van gegroepeerde gegevens — vergelijk verdelingen over een reeks, zonder aanmelding.`)
};

const fr_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un graphique en crêtes (joyplot) à partir de données groupées — comparez des distributions sur une séquence, sans inscription.`)
};

const it_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico ridgeline (joyplot) da dati raggruppati — confronta distribuzioni lungo una sequenza, senza registrazione.`)
};

const pt_br2_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um ridgeline (joyplot) a partir de dados agrupados — compare distribuições ao longo de uma sequência, sem cadastro.`)
};

const pt_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico ridgeline (joyplot) a partir de dados agrupados — compare distribuições ao longo de uma sequência, sem registo.`)
};

const ja_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ化されたデータからリッジラインプロット(ジョイプロット)を作成 — 連続するグループ間の分布を比較、サインアップ不要。`)
};

const zh_ridge_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据分组数据创建山脊图（joyplot）— 比较一个序列中的分布变化，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_tool_description", locale)
	if (locale === "en") return en_ridge_tool_description(inputs)
	if (locale === "es") return es_ridge_tool_description(inputs)
	if (locale === "de") return de_ridge_tool_description(inputs)
	if (locale === "nl") return nl_ridge_tool_description(inputs)
	if (locale === "fr") return fr_ridge_tool_description(inputs)
	if (locale === "it") return it_ridge_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_tool_description(inputs)
	if (locale === "pt") return pt_ridge_tool_description(inputs)
	if (locale === "ja") return ja_ridge_tool_description(inputs)
	return zh_ridge_tool_description(inputs)
};